module.exports = __webpack_public_path__ + "img/light-fm-Path 38@3x.1e8d0f7a.png";